<template>
  <img ref="imgRef" style="object-fit: cover" :src="url" v-on="$listeners" />
</template>

<script>
export default {
  props: {
    /**
     * "avatar" | "article";
     */
    type: {
      type: String,
      default: "avatar",
    },
    src: String,
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 200,
    },
  },
  computed: {
    defaultImg() {
      const imgMap = {
        article:
          "https://static.aipiaxi.com/app/web/images/behavior-calendar/bg_default_picture.png",
        avatar:
          "https://static.aipiaxi.com/image/2023/01/FgK0thWTKhi381SBnvLL5_7cGEEU.png",
      };
      return imgMap[this.type || "article"];
    },
    url() {
      return this.src
        ? `${this.src}?imageView2/1/w/${this.width}/h/${this.height}`
        : this.defaultImg;
    },
  },
  mounted() {
    const onError = (e) => {
      if (e.type == "error") {
        e.target.src = this.defaultImg;
      }

      this.$refs.imgRef.removeEventListener("error", onError);
    };
    this.$refs.imgRef.addEventListener("error", onError);
    this.$refs.imgRef.src = this.url;
  },
};
</script>

<style lang="less" scoped></style>
